import { Row } from "PFApp/booking/types";
import { RowType } from "PFApp/booking/types/row";
import { useMemo } from "react";

import { getOriginalResource } from "../../../helpers";
import { useMisalignments } from "../../../hooks";
import {
  BAR_HEIGHT,
  OVERBOOKINGS_HEIGHT,
  OVERBOOKINGS_TOP,
  ROW_PADDING,
  VERTICAL_BARS_MARGIN
} from "../../calendar/calendar";
import { WorkforceCalendarData } from "../../context/booking_overview_context.types";
import { useBookingRowsContext } from "../../context/booking_rows_context";
import { useBookingsOverviewContext } from "../../context/bookings_overview_context";

export const useRowMinHeight = ({ row }: { row: Row }) => {
  const { calendarMode } = useBookingsOverviewContext<WorkforceCalendarData>();
  const { barsByRowKey, warningsByProfile } = useBookingRowsContext();
  const { misalignmentBars } = useMisalignments({ row, mode: calendarMode });

  const getWarnings = () => {
    if (row.type !== RowType.Profile) {
      return null;
    }
    const profileId = getOriginalResource(row, calendarMode)?.id;
    return profileId ? warningsByProfile?.[profileId] : null;
  };

  return useMemo(() => {
    const warnings = getWarnings();
    const overbookinsHeight = warnings?.overbookings?.length ? OVERBOOKINGS_HEIGHT + OVERBOOKINGS_TOP : 0;
    const bars = barsByRowKey[row.key] ?? [];
    const bookingBarsHeight = bars.length * BAR_HEIGHT;
    const misalignmentsHeight = misalignmentBars.length * BAR_HEIGHT;
    const numberOfSubRows = Math.max(bars.length, misalignmentBars.length);
    return (
      Math.max(bookingBarsHeight, misalignmentsHeight) +
      overbookinsHeight +
      VERTICAL_BARS_MARGIN * numberOfSubRows +
      2 * ROW_PADDING
    );
  }, [barsByRowKey, row, warningsByProfile, misalignmentBars.length]);
};
